exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-quantity[data-v-9f8eb0cc]{position:relative}.product-quantity[data-v-9f8eb0cc] .spinner{position:absolute;top:calc(50% - 20px);right:0;bottom:0;left:calc(50% - 20px);margin:auto;padding:0 !important}\n", ""]);

// exports
